import { useInstitutionContext } from "@hooks/institutionContext";
import { LoadingSkeleton } from "@narmi/design_system";
import { useNotificationContext } from "cerulean/src/NotificationContext/NotificationContext";
import { useEffect } from "react";
import { $staffApi } from "../../api";
import { ErrorPage } from "../errors/ErrorPage";
import ReportsPageReportsTable from "./ReportsPageReportsTable";
import ReportsPageTeamTable from "./ReportsPageTeamTable";

const ReportsPage = () => {
  const { institution } = useInstitutionContext();
  const { data, isLoading, error } = $staffApi.useQuery("get", "/api/reports/config/", undefined, {
    // Api fetches data that does not change frequently and is not user-specific, so we can avoid unnecessary refetches
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  if (isLoading) {
    return <LoadingSkeleton isLoading />;
  }

  if (error || !data) {
    return (
      <ErrorPage
        title="Unable to load reports"
        text="An error occurred while loading reports configuration. Please try again later."
      />
    );
  }

  const {
    legacy_reports: legacyReports,
    available_billing_months: availableBillingMonths,
    display_billing_reports: displayBillingReports,
    has_fednow_report_access: hasFedNowReportAccess,
  } = data;

  return (
    <>
      {institution.sisense_enabled && <SisenseIFrame />}
      <div className="padding--bottom--m">
        <ReportsPageReportsTable
          legacy_reports={legacyReports}
          availableBillingMonths={availableBillingMonths}
          displayBillingReports={displayBillingReports}
          hasFedNowReportAccess={hasFedNowReportAccess}
        />
      </div>
      {institution.sisense_enabled && <ReportsPageTeamTable />}
    </>
  );
};

const SisenseIFrame = () => {
  const { sendNotification } = useNotificationContext();
  const { data, isLoading, isFetching, error } = $staffApi.useQuery(
    "get",
    "/api/reports/sisense/iframe/"
  );

  useEffect(() => {
    if (error) {
      sendNotification({
        type: "negative",
        text: "Failed to load Sisense iframe.",
      });
    }
  }, [error, sendNotification]);

  if (isLoading || isFetching) {
    return <LoadingSkeleton isLoading />;
  }

  return (
    <>
      {data?.iframe_url ? (
        <div className="padding--bottom--m">
          <iframe
            title="dashboard"
            src={data.iframe_url}
            frameBorder="0"
            height="900"
            width="100%"
          />
        </div>
      ) : null}
    </>
  );
};

export default ReportsPage;
